"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AuthProvider = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = _interopRequireDefault(require("../index"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Authentication provider
 * @returns {object} authentication functions
 */
var AuthProvider = function AuthProvider() {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isAuthentified = _useState2[0],
      setIsAuthentified = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      initializing = _useState4[0],
      setInitializing = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      user = _useState6[0],
      setUser = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      fireBaseuser = _useState8[0],
      setFireBaseUser = _useState8[1];

  var _useState9 = (0, _react.useState)(null),
      _useState10 = _slicedToArray(_useState9, 2),
      token = _useState10[0],
      setToken = _useState10[1];

  var _useState11 = (0, _react.useState)(null),
      _useState12 = _slicedToArray(_useState11, 2),
      loginError = _useState12[0],
      setLoginError = _useState12[1];
  /**
   * Callback when authenticated firebase user state changes
   * @param {object} fbUser current firebase user
   */


  var onAuthStateChanged = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(fbUser) {
      var doc;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (fbUser && fbUser.uid) {
                doc = _index["default"].firestore.collection('user').doc(fbUser.uid);
                doc.onSnapshot( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(fsUser) {
                    var fsUserData, holidayList, snp, exists, megedUser;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            fsUserData = fsUser.data();

                            if (!(!fsUserData || fsUserData.ts_deleted || fsUserData.status === 0)) {
                              _context.next = 5;
                              break;
                            }

                            setLoginError(fsUserData.status === 0 ? 'Votre compte est suspendu' : 'Erreur de connexion');
                            logout();
                            return _context.abrupt("return");

                          case 5:
                            holidayList = _index["default"].firestore.collection('holiday');
                            _context.next = 8;
                            return holidayList.where('ref_user', '==', doc).where('date_end', '>=', new Date()).where('ts_deleted', '==', null).where('accepted', '==', 1).get();

                          case 8:
                            snp = _context.sent;
                            exists = false;
                            snp.forEach(function (d) {
                              var data = d.data();

                              if (data.date_start.seconds <= new Date().getTime() / 1000) {
                                exists = true;
                              }
                            });

                            if (!exists) {
                              _context.next = 15;
                              break;
                            }

                            setLoginError('Impossible, vous êtes en congés');
                            logout();
                            return _context.abrupt("return");

                          case 15:
                            setLoginError(null);
                            megedUser = _objectSpread(_objectSpread({}, fbUser), fsUserData);

                            if (!_index["default"].firebaseAuth.currentUser) {
                              _context.next = 23;
                              break;
                            }

                            _context.t0 = setToken;
                            _context.next = 21;
                            return _index["default"].firebaseAuth.currentUser.getIdToken();

                          case 21:
                            _context.t1 = _context.sent;
                            (0, _context.t0)(_context.t1);

                          case 23:
                            setFireBaseUser(_objectSpread({
                              id: fsUser.id
                            }, fsUser.data()));
                            setUser(megedUser);
                            setIsAuthentified(!!megedUser);
                            if (initializing) setInitializing(false);

                          case 27:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }(), function (err) {
                  console.log("Encountered error: ".concat(err));
                });
              } else {
                setInitializing(false);
                setUser(null);
                setFireBaseUser(null);
                setToken(null);
                setIsAuthentified(false);
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onAuthStateChanged(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    if (user !== null && user !== void 0 && user.ts_deleted || (user === null || user === void 0 ? void 0 : user.status) === 0) {
      logout();
    }
  }, [user]);
  (0, _react.useEffect)(function () {
    var subscriber = _index["default"].firebaseAuth.onAuthStateChanged(onAuthStateChanged);

    return subscriber; // unsubscribe on unmount
  }, []);
  /**
   * Sign in a user
   * @param {string} email firebase user email
   * @param {string} password firebase user password
   * @returns {object} firebase sign response
   */

  var login = function login(email, password) {
    setLoginError(null);
    return _index["default"].firebaseAuth.signInWithEmailAndPassword(email.trim(), password);
  };
  /**
   * Sign up a user
   * @param {string} email firebase user email
   * @param {string} password firebase user password
   * @returns {object} firebase signup response
   */


  var signUp = function signUp(email, password) {
    return _index["default"].firebaseAuth.createUserWithEmailAndPassword(email, password).then(function (response) {
      var fbuser = {
        uid: response.user.uid,
        email: email
      };

      _index["default"].firestore.collection('user').doc(response.user.uid).set(fbuser);

      console.log('User account created & signed in!');
    });
  };
  /**
   * Send a reset password email with firebase
   * @param {string} email firebase user email
   * @returns {object} firebase reset password response
   */


  var sendPasswordResetEmail = function sendPasswordResetEmail(email) {
    return _index["default"].firebaseAuth.sendPasswordResetEmail(email);
  };
  /**
   * Process logout to the current authenticated firebase user
   */


  var logout = function logout() {
    _index["default"].firebaseAuth.signOut().then(function () {
      console.log('User signed out!');
      setUser(null);
    });
  };

  return {
    isAuthentified: isAuthentified,
    initializing: initializing,
    user: user,
    fireBaseuser: fireBaseuser,
    login: login,
    loginError: loginError,
    logout: logout,
    signUp: signUp,
    token: token,
    sendPasswordResetEmail: sendPasswordResetEmail
  };
};

exports.AuthProvider = AuthProvider;
AuthProvider.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired
};
var _default = AuthProvider;
exports["default"] = _default;